/**
 * Standalone setup page — 10-step onboarding wizard.
 *
 * Route: `/setup` (no token).
 *
 * This is the operator-facing first-launch wizard that polishes the
 * full standalone install. It is distinct from `/setup/$token` which
 * is the install-token bootstrap flow (called from `argus-install.sh`
 * with a one-time token printed to stdout).
 *
 * The token flow is for the very first sysadmin + tenant bootstrap.
 * Once that lands (or in dev environments where the operator is
 * already inside the box), this `/setup` route picks up the rest of
 * the 10-step walkthrough: profile, model, users, features, data,
 * smoke test, and final completion.
 *
 * Pre-auth: the wizard runs before any user session exists.
 * `/api/v1/setup/state` returns `currentStep` based on platform_setup
 * ledger state. The wizard auto-redirects to /ask-argus once the
 * `complete` step lands.
 */

import { createFileRoute } from '@tanstack/react-router';
import { SetupWizard } from '@/components/setup/SetupWizard';

export const Route = createFileRoute('/setup/')({
  component: SetupIndexPage,
});

function SetupIndexPage() {
  return <SetupWizard />;
}
